import { useRouter } from 'next/router'
import NProgress from 'nprogress'
import { useEffect } from 'react'

/**
 * Integrates NProgress with Next.js router events to show a loading bar
 * during route transitions.
 */
export const useRouterProgress = () => {
    const router = useRouter()

    useEffect(() => {
        // Memory leak fix: use stable function references so .off() actually removes them
        const onStart = () => NProgress.start()
        const onDone = () => NProgress.done()
        const onError = (err: { cancelled: boolean }, url: string) => {
            NProgress.done()
            // When a deployment changes the build ID, client-side navigation
            // fails with 404 because old _next/data files no longer exist.
            // Force a full page reload to pick up the new build.
            if (!err.cancelled && typeof window !== 'undefined') {
                window.location.href = url
            }
        }

        router.events.on('routeChangeStart', onStart)
        router.events.on('routeChangeComplete', onDone)
        router.events.on('routeChangeError', onError)

        return () => {
            router.events.off('routeChangeStart', onStart)
            router.events.off('routeChangeComplete', onDone)
            router.events.off('routeChangeError', onError)
        }
    }, [router])
}
